import { isEmpty } from '@axl/accel-framework/utils';
import AppNavigator from 'App/AppNavigator';
import qs from 'qs';
import { useMemo } from 'react';
import { useLocation, useMatch, useNavigate, useParams as useRouteParams } from 'react-router';

export function useRouter<T = {}>() {
    const match = useMatch('*');
    const location = useLocation();
    const navigate = useNavigate();
    const navigator = useMemo(() => new AppNavigator(navigate), [navigate]);
    const params = useParams<T>();
    return {
        match,
        location,
        params,
        navigate,
        navigator,
        // TODO replace all usages with navigate => delete
        history: {
            push: (url: string) => navigate(url),
            replace: (url: string) => navigate(url, { replace: true })
        }
    };
}

export function useParams<T>(): T {
    const routeParams = useRouteParams();

    let searchParams = {};
    const location = useLocation();
    if (!isEmpty(location.search))
        searchParams = qs.parse(location.search.substr(1));

    let hashParams = {};
    if (!isEmpty(location.hash)) {
        hashParams = qs.parse(location.hash.substr(1));
    }
    return { ...routeParams, ...searchParams, ...hashParams } as any;
}